(function() {
  const UPDATE_INTERVAL_MS = 1000;
  const NOTIFICATION_CLOSING_TIME_MS = 800;
  const SESSION_STORAGE_KEY = "closedNotificationBars";

  const init = function() {
    showUnclosedNotificationBars();

    if(document.querySelectorAll(".notification-bar").length) {
      if(Helpers.ssTest()) {
        document.querySelectorAll(".notification-bar").forEach((element)=> {
          element.classList.remove("hidden");
        });

        document.querySelectorAll(".notification-bar__close").forEach((element)=> {
          element.addEventListener("click", function(event) {
            const notificationBar = this.parentNode;
            closeNotificationBar(notificationBar);
            addToSessionStorage(notificationBar.id);
          });
        });
      }
    }

    if(document.querySelectorAll(".notification-bar__countdown").length) {
      updateCountDowns();

      setInterval(function() {
        updateCountDowns();
      }, UPDATE_INTERVAL_MS);
    }
  };

  const showUnclosedNotificationBars = function() {
    const sessionStorageIds = getSessionStorageIds();

    document.querySelectorAll(".notification-bar").forEach((element)=> {
      if(sessionStorageIds.indexOf(element.id) < 0) {
        element.classList.remove("hidden");
      } else {
        element.remove();
      }
    });
  };

  const addToSessionStorage = function(notificationBarId) {
    const sessionStorageIds = getSessionStorageIds();
    sessionStorageIds.push(notificationBarId);
    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(sessionStorageIds));
  };

  const getSessionStorageIds = function() {
    let sessionStorageIds = [];

    if(sessionStorage.getItem("closedNotificationBars") !== null) {
      sessionStorageIds = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEY));
    }

    return sessionStorageIds;
  };

  const closeNotificationBar = function(notificationBar) {
    notificationBar.remove();
  };

  const updateCountDowns = function() {
    document.querySelectorAll(".notification-bar__countdown").forEach((element)=> {
      updateCountdown(element);
    });
  };

  const updateCountdown = function(countdownNotification) {
    const msToEndDate = parseInt(countdownNotification.querySelector(".end-date").textContent) * 1000;
    const endDate = new Date(msToEndDate);
    const dateNow = new Date();
    const timeDifference = endDate - dateNow;

    if(timeDifference <= 0) {
      closeNotificationBar(countdownNotification.parentNode);
    } else {
      const displayTimeString = getDisplayTimeString(timeDifference);
      countdownNotification.querySelector(".countdown-display").textContent = displayTimeString;
    }
  };

  const getDisplayTimeString = function(timeDifference) {
    const timeDifferenceDate = new Date(timeDifference);

    const hours = padWithZero(Math.floor(timeDifference / 1000 / 60 / 60));
    const minutes = padWithZero(timeDifferenceDate.getUTCMinutes());
    const seconds = padWithZero(timeDifferenceDate.getUTCSeconds());

    return hours + ":" + minutes + ":" + seconds;
  };

  const padWithZero = function(num) {
    if(num < 10) {
      num = "0" + num;
    }

    return num;
  };

  init();
})();
